import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getClassNameFactory, getRehydratableName } from "../../../../utilities";
import PopoverContent from "../PopoverContent/PopoverContent";
import PopoverTrigger from "../PopoverTrigger/PopoverTrigger";
import { Manager, Popper, Reference } from "react-popper";
import uniqueId from "lodash/uniqueId";

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Popover.displayName));

    _defineProperty(_assertThisInitialized(_this), "popoverRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          onChange = _this$props.onChange;

      _this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      }, function () {
        if (onChange && id) {
          onChange(id);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.preventDefault();

      if (_this.props.triggerType === "click") {
        _this.toggle();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (_this.popoverRef.current) {
        if (_this.state.active && !_this.popoverRef.current.contains(e.target)) {
          _this.toggle();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyEnter", function (e) {
      if (_this.props.triggerType === "click") {
        if (e.key === "Enter") {
          e.preventDefault();

          _this.toggle();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      if (_this.props.triggerType === "hover") {
        _this.toggle();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      if (_this.props.triggerType === "hover") {
        _this.toggle();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      if (!_this.state.active) {
        return;
      } // document.activeElement is a fallback for IE11


      var nextFocusedElement = event.relatedTarget || document.activeElement;

      if (nextFocusedElement && _this.popoverRef.current && !_this.popoverRef.current.contains(nextFocusedElement)) {
        _this.toggle();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "uniqueIdForContent", uniqueId("popoverContent-"));

    _defineProperty(_assertThisInitialized(_this), "uniqueIdForTrigger", uniqueId("popoverTrigger-"));

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("click", this.handleClickOutside); // making sure that trigger id is unique since there might by multiple popovers on page
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("click", this.handleClickOutside);
    } // Ability for component to be controlled externally

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$ariaLabe = _this$props2.ariaLabelForTrigger,
          ariaLabelForTrigger = _this$props2$ariaLabe === void 0 ? "Trigger for popover" : _this$props2$ariaLabe,
          boxClass = _this$props2.boxClass,
          boxStyles = _this$props2.boxStyles,
          children = _this$props2.children,
          _this$props2$roleForC = _this$props2.roleForContainer,
          roleForContainer = _this$props2$roleForC === void 0 ? "tooltip" : _this$props2$roleForC,
          modifiers = _this$props2.modifiers,
          openDirection = _this$props2.openDirection,
          trigger = _this$props2.trigger,
          triggerType = _this$props2.triggerType,
          handleFocusOnElementInContent = _this$props2.handleFocusOnElementInContent,
          ariaLabelledById = _this$props2.ariaLabelledById,
          triggerClassName = _this$props2.triggerClassName,
          handleForceUpdateContent = _this$props2.handleForceUpdateContent;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.popoverRef,
        className: this.getClassName(),
        "data-rehydratable": getRehydratableName(Popover.displayName)
      }, /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/React.createElement("div", {
          className: _this2.getClassName({
            descendantName: "trigger"
          }),
          "data-rehydratable-trigger": true
        }, /*#__PURE__*/React.createElement(PopoverTrigger, {
          triggerId: _this2.uniqueIdForTrigger,
          triggerClassName: triggerClassName,
          ariaLabelledById: ariaLabelledById,
          ariaLabel: ariaLabelForTrigger,
          onToggle: _this2.toggle,
          handleClick: _this2.handleClick,
          handleKeyEnter: _this2.handleKeyEnter,
          handleMouseEnter: _this2.handleMouseEnter,
          handleMouseLeave: _this2.handleMouseLeave,
          idForContent: _this2.uniqueIdForContent,
          isActive: _this2.state.active,
          triggerNode: trigger,
          triggerRef: ref,
          triggerType: triggerType
        }));
      }), /*#__PURE__*/React.createElement(Popper, {
        placement: openDirection,
        modifiers: modifiers
      }, function (_ref2) {
        var ref = _ref2.ref,
            style = _ref2.style,
            placement = _ref2.placement,
            scheduleUpdate = _ref2.scheduleUpdate;
        return /*#__PURE__*/React.createElement(PopoverContent, {
          boxClass: boxClass,
          boxStyles: boxStyles,
          contentPlacement: placement,
          contentRef: ref,
          contentStyle: style,
          id: _this2.uniqueIdForContent,
          isActive: _this2.state.active,
          role: roleForContainer,
          handleForceUpdateContent: handleForceUpdateContent,
          scheduleUpdate: scheduleUpdate,
          handleFocus: handleFocusOnElementInContent,
          handleBlur: _this2.handleBlur
        }, /*#__PURE__*/React.createElement("span", {
          className: _this2.getClassName({
            descendantName: "children"
          }),
          "data-rehydratable-children": true
        }, children));
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.hasOwnProperty("onChange") && typeof props.active !== "undefined") {
        return {
          active: props.active
        };
      }

      return state;
    } // Event handlers

  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "displayName", "Popover");

_defineProperty(Popover, "defaultProps", {
  boxClass: "dropShadow",
  triggerType: "click",
  openDirection: "auto"
});

export default Popover;